function LogoMobile(props) {
  return <img alt="Logo" src="/static/logo_mobile.png" {...props} />;
}

export default LogoMobile;
